import React, { useEffect, useRef, useState } from 'react';
import '../../assets/css/Home/Home_Service.css';
import { API_BASE_URL } from '../../utils/config';

function ServicesSection() {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [centerTileIndex, setCenterTileIndex] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const observer = useRef(null);

    useEffect(() => {
        // Fetch des services depuis l'API
        fetch(`${API_BASE_URL}/services/home`)
            .then((response) => response.json())
            .then((data) => {
                const formattedData = data.map((service) => ({
                    id: service.id,
                    title: service.nom,
                    description: service.description_courte || 'Description non disponible',
                    background_image: `https://storage.croixblanche-42.org/sfcb42-website/services/${service.id}.webp`,
                }));
                setServices(formattedData);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Erreur lors de la récupération des services:', error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (!isMobile) {
            setCenterTileIndex(null); // Ne pas utiliser l'observateur sur PC
            return;
        }

        if (observer.current) observer.current.disconnect();

        const elements = document.querySelectorAll('.service-tile-wrapper');
        observer.current = new IntersectionObserver(
            (entries) => {
                let closestToCenter = null;
                let minDistanceToCenter = Infinity;

                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const rect = entry.boundingClientRect;
                        const distanceToCenter = Math.abs(rect.top + rect.height / 2 - window.innerHeight / 2);
                        if (distanceToCenter < minDistanceToCenter) {
                            minDistanceToCenter = distanceToCenter;
                            closestToCenter = parseInt(entry.target.dataset.index, 10);
                        }
                    }
                });

                if (closestToCenter !== null) {
                    setCenterTileIndex(closestToCenter);
                }
            },
            {
                threshold: 0.5,
                rootMargin: '0px 0px -50% 0px',
            }
        );

        elements.forEach((element) => observer.current.observe(element));

        return () => observer.current.disconnect();
    }, [isMobile, services]);

    return (
        <div className="services-section container my-5">
            <h2 className="section-title">Nos Actions</h2>

            {loading ? (
                <div className="row">
                    {[...Array(4)].map((_, index) => (
                        <div key={index} className="col-md-6 mb-4">
                            <div className="service-tile-placeholder">
                                <div className="service-image-placeholder"></div>
                                <div className="service-description-placeholder">
                                    <div className="placeholder-title"></div>
                                    <div className="placeholder-line"></div>
                                    <div className="placeholder-line"></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="row">
                    {services.map((service) => (
                        <div
                            key={service.id}
                            className="col-md-6 mb-4 service-tile-wrapper desktop-visible"
                            data-index={service.id}
                        >
                            <div className="service-tile">
                                <div
                                    className="service-image"
                                    style={{
                                        backgroundImage: `url(${service.background_image})`,
                                    }}
                                ></div>
                                <div
                                    className={`service-description-container ${
                                        isMobile
                                            ? centerTileIndex === service.id
                                                ? 'visible'
                                                : ''
                                            : ''
                                    }`}
                                >
                                    <h5 className="service-title">{service.title}</h5>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ServicesSection;
